module.exports = __webpack_public_path__ + "static/ukraine-c9205a6c733c18ce198bc045dc314e07.png";